import { render } from "./AboutIntroComp.vue?vue&type=template&id=67c3c8f4&scoped=true"
import script from "./AboutIntroComp.vue?vue&type=script&lang=js"
export * from "./AboutIntroComp.vue?vue&type=script&lang=js"

import "./AboutIntroComp.vue?vue&type=style&index=0&id=67c3c8f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c3c8f4"]])

export default __exports__